<template>
  <div class="warpNavlan" ref="teamRef">
       <div class="box-one" ref="gsap-context">
         <div class="center">
           <div>
             <span>
              团队优势
             </span>
           </div>
         </div>
       </div>
       <div class="box-two" ref="gsap-box">
         <div class="context">
           
           <div class="context-one">
              <div class="text-one">
                  团队介绍
                  <!-- <span style="font-size: 20px;">团队优势（资源优势、决策优势、创新优势、绩效优势、素质优势）</span> -->
              </div>
              <div class="text-two" style="margin-bottom: 10px;"></div>
              <div class="test-box">
                <ol>
                  <li>
                    专业团队<br>
我们具有一支由技术、设计师和市场营销人员等组成的实力雄厚的高效研发团队，每个成员都在自己的领域内具备深厚的专业知识和丰富的实践经验。
                  </li>
                  <li>
                    专业的客服支持<br>
公司运营团队提供专业的客服支持，帮助商户解决消费者的问题和投诉，提供贴心服务.
                  </li>
                  <li>
                    技术创新能力强<br>
我们的技术专家拥有广泛的技术背景和敏锐的行业理解能力，在技术创新方面标新立异，他们熟悉各种开发语言和技术框架，并能根据项目需求提供最优的解决方案。无论是网站的开发、移动程序应用还是人工智能技术，我们公司团队都能够为客户提供高质量的技术支持和服务.
                  </li>
                  <li>
                    丰富的运营经验<br>
公司运营团队累积了丰富的运营经验，他们了解市场需求和竞争情况，能够根据入驻商家的特点和目标定制运营策略，提高竞争力.
                  </li>
                  <li>
                    数据分析和优化<br>
公司运营团队通过专业的数据分析工具，对商家线上经营数据进行全面、深入的分析，找出问题并定制相应的优化方案，提升商家在平台的曝光度和转化率.
                  </li>
                  <li>
                    全面服务<br>
繁淼运营团队提供全面服务，包括线上店铺装修、商品上架、订单管理、售后服务等，帮助您全面提升线上运营效果，提供更好的消费者体验，增加用户的粘性和复购率.
                  </li>
                </ol>
              </div>
              <!-- <div class="text-three">
                  <div style="border: 1px solid rgba(0,0,0,0.1);padding: 10px;box-sizing: border-box;border-radius: 10px;">
                    我们团队的优势在于多方面的专业知识和经验。我们据有一支由技术专惠、设计师和市
                    场营铜人员组成的高效团队，每个成员都在自己的领感内县备深厚的专业知说和丰富的
                    实践经验。
                  </div>
              </div>
              <div class="text-four">
                  <div style="border: 1px solid rgba(0,0,0,0.1);padding: 10px;box-sizing: border-box;border-radius: 10px;">
                    首先，我们的技术专家拥有广泛的技术背乘和深入的行业理解，他们熟悉各种开发语言
和技术框架，井能根据项目需求提供最佳的解决方毫。无论是网站开发、移动应用还是
人工智能技术，我们团队都能够为客户提供高质量的技术支持。
                  </div>
              </div>
              <div class="text-five">
                <div style="border: 1px solid rgba(0,0,0,0.1);padding: 10px;box-sizing: border-box;border-radius: 10px;">
                    首先，我们的技术专家拥有广泛的技术背乘和深入的行业理解，他们熟悉各种开发语言
和技术框架，井能根据项目需求提供最佳的解决方毫。无论是网站开发、移动应用还是
人工智能技术，我们团队都能够为客户提供高质量的技术支持。
                  </div>
              </div> -->
           </div>
           <div class="context-two">
            
           </div>
         </div>
       </div>
  </div>
</template>
<script>
import { gsap } from "gsap";
export default {
 name: 'child',
 data(){
   return{
      
   }
 },
 mounted() { 
  this.initAnFun();
 },
 methods:{
  initAnFun(){

    let observer = new IntersectionObserver((enter)=>{
      if(enter[0].isIntersecting){
          let title = this.$refs['gsap-context'];
          let box = this.$refs['gsap-box'];

          gsap.from(title,{
            y:'-100%',
            duration: 3.6,
            ease:'power2.out'
          })
          gsap.from(title,{
            opacity:1,
            duration: 3,
            ease:'power2.out'
          })
          gsap.from(box,{
            y:'100%',
            duration: 3.6,
            ease:'power2.out'
          })
        observer.unobserve(this.$refs.teamRef)
      }
    },{
      root: null,
      threshold: 0.3
    })
    observer.observe(this.$refs.teamRef)
    }
 }
}
</script>
<style lang="scss" scoped>
   .warpNavlan{
     width: 100%;
     height: 1080px;
     background: #FFFFFF;
     position: relative;
     box-sizing: border-box;
     padding-top: 106px;
     background-image: url('../../../assets/team-bg.png');
     background-size: 100% 100%;
     .box-one{
       width: 100%;
       display: flex;
       justify-content: center;
       margin-bottom: 83px;
       .center{
         width: 681px;
         height: 98px;
         background-image: url('../../../assets/team-title.png');
         background-size: 100% 100%;
         div{
           height: 100%;
           display: flex;
           justify-content: center;
           align-items: flex-end;

           span{
            font-size: 40px;
            font-family: Alibaba_Bold;
            color: #FFFFFF;
            line-height: 56px;
           }
         }
       }
       // 
     }
     .box-two{
       display: flex;
       justify-content: center;
       .context{
        width: 1200px;
        height: 630px;
        background: #FFFFFF;
        border-radius: 10px;
        display: flex;
        overflow: hidden;
         
         .context-one{
           width: calc(100% - 552px);
           height: 100%;
           box-sizing: border-box;
           padding-top: 100px;
           box-sizing: border-box;
           padding-left: 50px;
           padding-top: 50px;
           padding-right: 50px;
           .text-one{
              font-size: 32px;
              font-family: Alibaba_Bold;
              color: #333333;
              line-height: 45px;
              margin-bottom: 18px;
           }
           .text-two{
              width: 34px;
              height: 5px;
              background: linear-gradient(90deg, #367CFF 0%, #80ACFF 100%);
              margin-bottom: 50px;
           }
           .text-three{
              font-size: 14px;
              font-family: Alibaba_Regular;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
           }
           .text-four{
              @extend .text-three;
              
              margin-top: 13px;
              margin-bottom: 13px;
           }
           .text-five{
              @extend .text-three;
           }
         }
         .context-two{
           width: 552px;
           height: 100%;
           background-image: url('../../../assets/team-bg1.png');
           background-size: 100% 100%;
           box-sizing: border-box;
           padding-top: 289px;
           padding-left: 40px;
           border-radius: 0;
         }
       }
     }
     .test-box{
        padding-left: 15px;
        ol{
          li{
              font-size: 12px;
              font-family: Alibaba_Regular;
              font-weight: 500;
              color: #333333;
              line-height: 24px;
              margin-bottom: 10px;
              letter-spacing: 1px;
          }
        }
     }
   }
</style>

